import { css, keyframes } from 'styled-components'

/**
 * Frosted glass of everything laid over the canvas — panels, bars, cards, chips: one look for all of them
 * (the surface colour at this share, the scene blurred through it).
 */
const GLASS_OPACITY = 72

export const glassSurface = css`
    background: color-mix(in srgb, ${({ theme }) => theme.colors.surface} ${GLASS_OPACITY}%, transparent);
    border: 1px solid ${({ theme }) => theme.colors.line};
    box-shadow: ${({ theme }) => theme.shadows.card};
    backdrop-filter: blur(16px) saturate(170%);
    -webkit-backdrop-filter: blur(16px) saturate(170%);
`

const dropIn = keyframes`
    from { opacity: 0; transform: translateY(-4px); }
    to { opacity: 1; transform: none; }
`

/**
 * Fade-in of a glass element of the top bar on mount. It goes on the glass element itself: a parent below full
 * opacity becomes the backdrop root, and the glass inside would show the scene unblurred until the fade ends.
 */
export const glassDropIn = css`
    /* Not held after the end: a held opacity would override the element's own (a disabled chip's, say). */
    animation: ${dropIn} ${({ theme }) => theme.motion.base} ease backwards;

    @media (prefers-reduced-motion: reduce) {
        animation: none;
    }
`
